import React from 'react';
import { StyleSheet } from 'react-native';
import { Button, rem } from 'design-system';
import useAppFrameDimensions from 'hooks/useAppFrameDimensions';
import useIsTablet from 'hooks/useIsTablet';
import useOnboarding from '../hooks/useOnboarding';
const CreateAPotButton = () => {
    const { paddingHorizontal } = useAppFrameDimensions(true);
    const [onboard, buttonTitle] = useOnboarding();
    const isTablet = useIsTablet();
    return (<Button brand floating onPress={onboard} title={buttonTitle} style={styles.button} testID="PotsProductTourOnboardBtn" containerStyle={[!isTablet && styles.buttonContainer, { marginHorizontal: paddingHorizontal }]}/>);
};
const styles = StyleSheet.create({
    button: {
        marginHorizontal: rem(16),
    },
    buttonContainer: {
        bottom: rem(16),
    },
});
export default CreateAPotButton;
